import { api } from "./client";
import type { ExportDraftFormat, FinalExportFormat, MonographSection } from "../types";

export async function buildMonographEn(projectId: string): Promise<{ job_id: string }> {
  const { data } = await api.post<{ job_id: string }>(
    `/projects/${projectId}/build-monograph-en`,
    {},
  );
  return data;
}

export async function translateProject(projectId: string): Promise<{ job_id: string }> {
  const { data } = await api.post<{ job_id: string }>(
    `/projects/${projectId}/translate`,
    {},
  );
  return data;
}

export async function buildMonographPt(projectId: string): Promise<{ job_id: string }> {
  const { data } = await api.post<{ job_id: string }>(
    `/projects/${projectId}/build-monograph-pt`,
    {},
  );
  return data;
}

export async function getMonograph(projectId: string): Promise<MonographSection[]> {
  const { data } = await api.get<MonographSection[]>(`/projects/${projectId}/monograph`);
  return data;
}

export async function downloadExportDraft(
  projectId: string,
  format: ExportDraftFormat,
): Promise<Blob> {
  const { data } = await api.get<Blob>(`/projects/${projectId}/export-draft`, {
    params: { format },
    responseType: "blob",
  });
  return data;
}

export async function downloadFinalExport(
  projectId: string,
  format: FinalExportFormat,
): Promise<Blob> {
  const { data } = await api.get<Blob>(`/projects/${projectId}/export`, {
    params: { format },
    responseType: "blob",
  });
  return data;
}
